import Component from './Component';

// Debug function to open the megamenu and its submenus
const debugmegamenu = () => {
  console.log('debugmegamenu');
  document.querySelector('.nav-builder')?.classList.add('expanded');
  document.querySelector('.dropdown-content')?.classList.add('open');
  document.querySelector('.submenu-container')?.classList.add('open');
  document.querySelector('.expandable-content')?.classList.add('open');
};
window.debugmegamenu = debugmegamenu;


export default class Header extends Component {
  load() {
    this.initHeader();
    super.load();
  }

  initHeader() {
    $('#primary-navigation .dropdown > .nav-link').on('click', (e) => {
      const $parent = $(e.currentTarget).parent();
      $('#primary-navigation .dropdown.active').not($parent).removeClass('active');
      $parent.toggleClass('active');
    });

    $('[data-toggle="menu"]').on('click', () => {
      const $slideoutMenu = $('.slideout-menu__wrapper');
      $('body').toggleClass('menu-open');

      if (!$('body').hasClass('menu-open')) {
        $slideoutMenu.on('transitionend', () => {
          $slideoutMenu.removeClass('show').off('transitionend');
        });
      } else {
        $slideoutMenu.toggleClass('show');
      }
    });

    $('.desktop-nav > li > a[href*="#"]:not([href="#"])').on('click', (e) => {
      const target = document.querySelector(`.slideout-menu [data-slug="${e.currentTarget.hash.slice(1)}"]`);
      this.currentElement = e.currentTarget;

      if (target) {
        e.preventDefault();
        $('.slideout-menu__wrapper').addClass('show');
        $('body').addClass('menu-open');
        if (!$(target).hasClass('active')) {
          $(target).find('> .nav-link').click().focus().blur();
        }
      }
    });

    $(document).on('keyup', (e) => {
      if (e.keyCode === 27 && $('body').hasClass('menu-open')) {
        $('body').removeClass('menu-open');

        if (this.currentElement) {
          this.currentElement.focus();
          this.currentElement = null;
        }
      }
    })

    this.initToggleContent();
    this.initSubToggleContent();
    this.navigationSearch();
  }

  // Initializes the toggle content for the navigation builder
  initToggleContent() {
    const body = document.body;
    const toggleButton = document.getElementById("nav-builder-header-toggle");
    const header = document.querySelector(".nav-builder");
    const mainNav = document.querySelector(".main-nav");
    const subNav = document.querySelector(".sub-nav");
    const mobileIcons = document.querySelector(".main-nav-mobile-icons");
    const searchBtn = document.querySelector(".search-button");
    const searchNav = document.querySelector(".searchNavigation");
    const predSearch  = document.querySelector(".predictive-search");

    if (searchBtn) {
      const btnIcon = searchBtn.querySelector('i');

      const setIconToSearch = () => {
        btnIcon.classList.replace('la-times', 'la-search');
      };
    }
  
    if (!toggleButton || !header) return;
  
    const isSmallScreen = () => window.innerWidth < 640;
    const isDesktop = () => window.innerWidth >= 1300;
  
    const toggleHeaderClass = () => {
      if (!isDesktop()) header.classList.toggle("open");
      if (isSmallScreen()) body.classList.add("no-scroll");
  
      searchNav.style.display = "none";
  
      if (header.classList.contains("search")) {
        header.classList.remove("open", "search");
        predSearch.classList.add("fade");
        mainNav.style.display     = "";
        subNav.style.display      = "flex";
        mobileIcons.style.display = "flex";
        searchNav.style.display   = "none";
        setIconToSearch();
      }
    };
  

    const closeNavigation = () => {
      header.classList.remove("open", "expanded");
      body.classList.remove("no-scroll");
  
      document.querySelectorAll('.main-nav-item.active').forEach(el => el.classList.remove("active"));
      document.querySelector(".submenu-items").style.transform = "translate(0)";

      const btnIcon = searchBtn.querySelector('i');

      const setIconToSearch = () => {
        btnIcon.classList.replace('la-times', 'la-search');
      };      
  
      if (searchBtn?.classList.contains("active")) {
        searchBtn.classList.remove("active");
        header.classList.remove("search");
        predSearch.classList.add("fade");
        mainNav.style.display     = "";
        subNav.style.display      = "flex";
        mobileIcons.style.display = "flex";
        searchNav.style.display   = "none";
        setIconToSearch();
      }
    };
  
    const handleHover = (event) => {
      const item = event.target.closest(".main-nav-item");
      if (!item) return;
    
      const contentId = item.getAttribute("data-target");
      const content = document.getElementById(contentId);
      if (!content) return;
    
      document.querySelectorAll(".dropdown-content").forEach(el => el.classList.remove("open"));
      document.querySelectorAll(".main-nav-item").forEach(el => el.classList.remove("active"));
    
      document.querySelectorAll(".sub-toggle").forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".expandable-content").forEach(el => el.classList.remove("open"));
      document.querySelectorAll(".submenu-container").forEach(el => el.classList.remove("open"));
      const submenuItems = document.querySelector(".submenu-items");
      if (submenuItems) submenuItems.style.transform = "translate(0)";
    
      item.classList.add("active");
      content.classList.add("open");
    
      const subtoggles = content.querySelectorAll(".sub-toggle");
      const subcontents = content.querySelector(".submenu-items")?.querySelectorAll(".expandable-content") || [];
      const tabbed = content.querySelector(".submenu-items.tabbed");
    
      if (window.innerWidth > 640 || subcontents.length === 1 || tabbed) {
        subtoggles[0]?.classList.add("active");
        subcontents[0]?.classList.add("open");
        subtoggles[0]?.closest(".submenu-container")?.classList.add("open");
      }
    
      const expanded = !!document.querySelector(".dropdown-content.open");
      header.classList.toggle("expanded", expanded);
    };
    
    const setupListeners = () => {
      const items = document.querySelectorAll(".main-nav-item");
      const useHover = isDesktop();
    
      items.forEach(item => {
        item.replaceWith(item.cloneNode(true));
      });
    
      const updatedItems = document.querySelectorAll(".main-nav-item");
    
      updatedItems.forEach(item => {
        item.addEventListener(useHover ? "mouseenter" : "click", handleHover);

        item.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleHover(e);
          }
        });
      });
    };
  
    toggleButton.addEventListener("click", toggleHeaderClass);

    document.addEventListener("click", e => {
      if (e.target.closest(".close-nav-builder")) closeNavigation();
    });
  
    header.addEventListener("mouseleave", () => {
      if (!document.querySelector(".main-nav-item:hover") && !document.querySelector(".sub-toggle:hover")) {
        header.classList.remove("expanded");
    
        document.querySelectorAll(".dropdown-content").forEach(el => el.classList.remove("open"));
        document.querySelectorAll(".main-nav-item").forEach(el => el.classList.remove("active"));
        
        document.querySelectorAll(".sub-toggle").forEach(el => el.classList.remove("active"));
        document.querySelectorAll(".expandable-content").forEach(el => el.classList.remove("open"));
        document.querySelectorAll(".submenu-container").forEach(el => el.classList.remove("open"));
        
        const submenuItems = document.querySelector(".submenu-items");
        if (submenuItems) submenuItems.style.transform = "translate(0)";
      }
    });
  
    window.addEventListener("resize", setupListeners);
    setupListeners();
  }

  initSubToggleContent() {
    const header = document.querySelector(".nav-builder");
    const subNavBack = document.getElementById("sub-nav-back");
    const subToggles = document.querySelectorAll(".sub-toggle");
  
    const handleClick = (e) => {
      const index = Array.from(subToggles).indexOf(e.currentTarget);
      document.querySelector(".submenu-items").style.transform = `translate(${-window.innerWidth * index}px)`;
    };
  
    const toggleSubContent = function () {
      const targetId = this.dataset.target;
      const content = document.getElementById(targetId);
      const container = this.closest(".submenu-container");
      if (!content) return;
  
      document.querySelectorAll(".sub-toggle").forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".expandable-content").forEach(el => el.classList.remove("open"));
  
      this.classList.add("active");
      content.classList.add("open");
      container?.classList.add("open");
    };
  
    const setupToggleListeners = () => {
      const isSmall = window.innerWidth < 640;
      const isTablet = window.innerWidth < 1300;
    
      subToggles.forEach(toggle => {
        const container = toggle.closest(".submenu-container");
        const tabbed = container?.classList.contains("tabbed");
    
        toggle.removeEventListener("click", toggleSubContent);
        toggle.removeEventListener("mouseenter", toggleSubContent);
        toggle.removeEventListener("click", handleClick);
    
        if (tabbed) {
          if (isSmall) {
            toggle.addEventListener("click", handleClick);
            toggle.addEventListener("click", toggleSubContent);
          } else if (isTablet) {
            toggle.addEventListener("click", toggleSubContent);
          } else {
            toggle.addEventListener("mouseenter", toggleSubContent);
          }
        } else {
          toggle.addEventListener("click", toggleSubContent);
        }
      });
    
      if (window.innerWidth > 1300 && header?.classList.contains("open")) {
        header.classList.remove("open");
      }
    };
  
    subNavBack?.addEventListener("click", () => {
      document.querySelectorAll(".submenu-container.open").forEach(el => el.classList.remove("open"));
      document.querySelectorAll(".expandable-content").forEach(el => el.classList.remove("open"));
      subToggles.forEach(el => el.classList.remove("active"));
  
      document.querySelector(".submenu-items").style.transform = "translate(0)";
  
      if (!document.querySelector('.submenu-items.tabbed .open')) {
        document.querySelectorAll(".main-nav-item").forEach(el => el.classList.remove("active"));
        document.querySelectorAll(".dropdown-content").forEach(el => el.classList.remove("open"));
        header?.classList.remove("expanded");
      }
    });
  
    setupToggleListeners();
    window.addEventListener("resize", setupToggleListeners);
  }

  navigationSearch() {
    const header      = document.querySelector(".nav-builder");
    const searchBtn   = document.querySelector(".search-button");
    const mainNav     = document.querySelector(".main-nav");
    const subNav      = document.querySelector(".sub-nav");
    const mobileIcons = document.querySelector(".main-nav-mobile-icons");
    const searchNav   = document.querySelector(".searchNavigation");
    const predSearch  = document.querySelector(".predictive-search");
    const searchNavButton = document.querySelector(".searchNavigation__button");
  
    if (!searchBtn || !header) return;

    const btnIcon = searchBtn.querySelector('i');

    const setIconToClose = () => {
      btnIcon.classList.replace('la-search', 'la-times');
    };

    const setIconToSearch = () => {
      btnIcon.classList.replace('la-times', 'la-search');
    };
  
    const openSearch = () => {
        header.classList.add("open", "search");
        searchBtn.classList.add("active");
        if (predSearch && predSearch.classList.contains("fade")){
          predSearch.classList.add("fade");
        }
        mainNav.style.display     = "none";
        subNav.style.display      = "none";
        mobileIcons.style.display = "none";
        searchNav.style.display   = "";
        setIconToClose();
    };
  
    const closeSearch = () => {
      header.classList.remove("open", "search");
      searchBtn.classList.remove("active");
      if (predSearch) {
        predSearch.classList.add("fade");
      }
      mainNav.style.display     = "";
      subNav.style.display      = "flex";
      mobileIcons.style.display = "flex";
      searchNav.style.display   = "none";
      setIconToSearch();
    };

    if (predSearch && searchNavButton) {
      const observer = new MutationObserver(() => {
        const isFadedOut = predSearch.classList.contains("fade");

        if (!isFadedOut) {
          searchNavButton.style.display = "none";
        } else {
          searchNavButton.style.display = "";
        }
      });

      observer.observe(predSearch, { attributes: true, attributeFilter: ['class'] });
    }
  
    searchBtn.addEventListener("click", () => {
      header.classList.contains("open") ? closeSearch() : openSearch();
    });

    window.addEventListener('resize', () => {
    if (header.classList.contains("search")) {
      closeSearch();
    }
    });

    const predictiveForm = document.getElementById('predictive-search-form');
    const hiddenInput = document.getElementById('predictive-search-hidden-input');
    const mainInput = document.getElementById('header-search-input');
    if (predictiveForm && hiddenInput && mainInput) {
      predictiveForm.addEventListener('submit', function (e) {
        hiddenInput.value = mainInput.value;
    });
    }
  }
}
